import React, { useMemo, useContext } from "react";
import UIFooter from "./UIFooter";
import styled from "styled-components";
import { useIsOnScreen } from "@arcteryx/components-hooks";
import PropTypes from "prop-types";
import { ScreenSize } from "@arcteryx/components-typography";
import { SiteContext } from "@arcteryx/components-contexts";

/** Safe distance to start loading the footer script in.
 * Unless the user is scrolling very fast the footer will load before it appears on screen
 */
export const UI_LAZY_FOOTER_DEFAULT_ROOT_MARGIN = "500px";

const FooterWrapperDiv = styled.div`
  min-height: ${(props) => props.mobileHeight};
  @media (min-width: ${(props) => props.breakPoint}) {
    min-height: ${(props) => props.desktopHeight};
  }
`;

/** Reserve space for the UIFooter element so that it doesn't cause scrollbar jank if it is lazy-loaded
  min-height determined by smallest height of Footer on different viewports for safety
*/
export const footerData = {
  outdoor: {
    mobileHeight: "814px",
    desktopHeight: "680px",
    breakPoint: `${ScreenSize.md}px`,
  },
  sale: {
    mobileHeight: "800px",
    desktopHeight: "713px",
    breakPoint: "900px",
  },
  leaf: {
    mobileHeight: "260px",
    desktopHeight: "260px",
    breakPoint: `${ScreenSize.md}px`,
  },
};

const LazyUIFooter = ({ deployEnv = "qa", rootMargin = UI_LAZY_FOOTER_DEFAULT_ROOT_MARGIN, uiBaseUrl = '' }) => {
  const { market } = useContext(SiteContext);
  const { ref, isOnScreen } = useIsOnScreen({ rootMargin });

  const minHeight = useMemo(() => {
    const theMarket = market || "leaf";
    return footerData[theMarket];
  }, [market]);

  return (
    <FooterWrapperDiv
      ref={ref}
      className="qa--footer"
      data-testid="qa--footer"
      mobileHeight={minHeight.mobileHeight}
      desktopHeight={minHeight.desktopHeight}
      breakPoint={minHeight.breakPoint}
    >
      {isOnScreen ? <UIFooter uiBaseUrl={uiBaseUrl} loadScript env={deployEnv} /> : null}
    </FooterWrapperDiv>
  );
};

LazyUIFooter.propTypes = {
  deployEnv: PropTypes.oneOf(["production", "stage", "qa"]),
  rootMargin: PropTypes.string,
  uiBaseUrl: PropTypes.string
};

export default LazyUIFooter;
